<div class="letter-container">
    <div class="letter-content">
      <h1>About All My Hugs</h1>
      <p>
        At All My Hugs, we believe that no distance or time gap should ever come between the moments 
        that matter most. Our story began in 2009 with when we realized that we could leverage our 
        programming and design skills to find remote work and fulfill our life long dreams of 
        travelling the world and living in most of it's cities. All My Hugs came to us naturally 
        after more than a decade spent exploring as many corners of the world as possible. 
        </p>
        <p>
        The convergance of new tech and old rules made the window for freedom timely and 
        relatively short lived. We saw this coming and grabbed the moment to take the journey. 
        </p>    
        <p>
        After that, Sabrina and I spent years blessed with amazing sights, sounds, smells and experiences. 
        We had our jaws on the floor with awe for over a decade, living in Kingdoms, dictatorships, 
        former war zones, active war zones, in countries that were experiencing freedom 
        for the first time, we lived in ancient little known cities, enourmous metropolises, 
        iconic landmark cities like Paris, we met many people and made some good friends 
        but all the time we missed family. I made it my mission to post photos online and 
        not to have us in too many of them in the hopes that family would see them and 
        feel like they were on the trip too, that we we were connected. 
        My adult children missed me and I miss them deeply. 
        </p>
        <p>
        Then in the middle of all this 
        our beautiful Grandchildren were born!
        </p>
        <p>
        It was while traveling far from home, too far away from the laughter and warmth of family 
        gatherings that the seed of an idea were planted: a way to bridge the gap created 
        by distance and time, so that even when separated, you can remain an integral part 
        of your loved ones lives.
        </p>
        <p>
        The inspiration to finally build our company and make it real came from personal experience, 
        a deep yearning to stay connected with grandchildren and family members even when the 
        miles between us felt insurmountable. We recognized that life’s most cherished 
        events—whether they are birthdays, anniversaries, or even life’s challenging moments 
        deserve to be celebrated with a personal touch, regardless of when or 
        where they occur.
        </p>
        <p>
        Today, All My Hugs offers you a unique way to plan ahead and share your heart. 
        All My Hugs allows you to create heartfelt presentations, custom letters, beautiful cards, 
        and thoughtfully selected gifts that can be scheduled for delivery months, years, or even 
        decades into the future. Imagine sending a message of encouragement on a significant milestone,
        or a special gift to mark an unforgettable day, ensuring that your love and support are 
        always just a click away. 
        </p>
        <p>
        Even after we are gone we can continue to support our children, 
        their children and their children's children. We can teach, share family stories, 
        photobooks words of encouragement and gifts.
        </p>
        <p>
        Our mission is simple: to empower you to maintain those irreplaceable connections, no matter 
        where life takes you or how far apart you may be. At All My Hugs, every feature is designed
        with care and intention, making it easier than ever to plan ahead and never miss an opportunity 
        to celebrate the unique journey of your loved ones. 
        </p>
        <p>
        Join us in creating a future filled with memorable moments, heartfelt surprises, and the enduring 
        bonds that make life truly extraordinary. With All My Hugs, every day is a chance to reconnect, 
        celebrate, and show that love knows no bounds.
        </p>
        <br />
    </div>
  </div>



